'use client';
import {StrapiBrand} from '@/types/strapi';
import Url from './Url';

export default function BrandList(Prop: {
  moduleOption: any;
  moduleData: StrapiBrand[];
}) {
  const {moduleData, moduleOption} = Prop;
  const sequence = moduleOption?.items || [];
  const brandItems = (moduleData || []).sort(
    (a, b) => sequence.indexOf(a.slug) - sequence.indexOf(b.slug)
  );

  return (
    <div className="questrial text-[18px]">
      <div className="flex flex-wrap gap-2">
        {brandItems.map((brand, index) => {
          const url = moduleOption?.urls?.[index] || '/brand/' + brand.slug;
          return (
            <div key={index} id={'brand-item-' + brand.slug} className="">
              <Url href={url}>
                {brand.logo && (
                  <img
                    src={brand.logo?.url}
                    alt={brand.title}
                    className="w-auto object-contain h-[50px] max-w-[100px]"
                  />
                )}
              </Url>
            </div>
          );
        })}
      </div>
    </div>
  );
}
